import { getCookie } from "./Cookie";

export function useAuth() {
  return {
    loggedIn() {
      return getCookie('_1') ? true : false
    }
  };
}